import { useLayoutEffect } from 'react'
import { useGeckoTheme } from 'styles/GeckoTheme'

import {
  DesignSystemTheme,
  useDesignSystemTheme,
  useDesignSystemThemeDocumentOverride,
} from './DesignSystemThemeProvider'
import { getDesignSystemThemeForGeckoMode } from './geckoDesignSystemThemeSync'

export function GeckoThemeDocumentSync(): null {
  const { themeMode, themeModeOverride } = useGeckoTheme()
  const { theme, setTheme } = useDesignSystemTheme()
  const expectedTheme = getDesignSystemThemeForGeckoMode(themeMode)

  useDesignSystemThemeDocumentOverride(
    themeModeOverride ? expectedTheme : undefined
  )

  useLayoutEffect(() => {
    if (themeModeOverride) {
      return
    }

    if (theme !== DesignSystemTheme.System && theme !== expectedTheme) {
      setTheme(expectedTheme)
    }
  }, [expectedTheme, setTheme, theme, themeModeOverride])

  return null
}
